import { render, staticRenderFns } from "./ResourcesView.vue?vue&type=template&id=46eea25a&scoped=true&"
import script from "./ResourcesView.vue?vue&type=script&lang=js&"
export * from "./ResourcesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eea25a",
  null
  
)

export default component.exports